//Alert.tsx
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { useDialog } from "@/hook/useDialog.ts";

export const Alert = () => {
    const {
        isOpen,
        close,
        props = {
            title: "",
            content: "",
            type: "ALERT",
            callback: undefined,
            confirmButtonText: "확인",
        },
    } = useDialog();
    const { title, content, type, callback, confirmButtonText = "확인" } = props;

    const handleConfirm = () => {
        if (callback) {
            callback();
        }
        close();
    };
    return (
        <AlertDialog onOpenChange={close} open={isOpen} defaultOpen={isOpen}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{title}</AlertDialogTitle>
                </AlertDialogHeader>
                <AlertDialogDescription className="text-black">{content ? `<hr/>${content}<hr />` : ""}</AlertDialogDescription>
                <AlertDialogFooter>
                    {type === "CONFIRM" && (
                        <AlertDialogCancel onClick={close} className="text-brand border-brand hover:text-brand">
                            닫기
                        </AlertDialogCancel>
                    )}
                    <AlertDialogAction
                        onClick={handleConfirm}
                        className={confirmButtonText === "삭제" ? "bg-red-500 text-zinc-50 hover:bg-red-500/90 dark:bg-red-900 dark:text-zinc-50 dark:hover:bg-red-900/90" : "bg-brand text-white hover:bg-brand-hover hover:text-white"}
                    >
                        {confirmButtonText || "확인"}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
